import InsuranceESGBarChart from "../components/InsuranceESGBarChart"
import InsuranceESGPieChart from "../components/InsuranceESGPieChart"
import InsuranceESGMap from "../components/InsuranceESGMap"
export default {

  components: {'risk-bar-chart': InsuranceESGBarChart, 'risk-pie-chart': InsuranceESGPieChart, 'ins-esg-map': InsuranceESGMap},
  data() {
    return {  
      formDatas: null,
      formData: null,
      filterDatas: null,
      bar_info_show: false,
      pie_info_show: false,
      map_info_show: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      },
      exportConfig: {},
      filter_company: '',
      filter_insurance_type: '',
      insurance_type_options: [],
    }
  },
  methods: {
    insurance_type_Filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    insuranceTypeChange(value, selectedOptions) {
      if (selectedOptions) this.filter_insurance_type = selectedOptions[0].label
      else this.filter_insurance_type = ''
    },

    getData() {
      var all_data = JSON.parse(window.sessionStorage.getItem('esg_risk'))
      this.formDatas = JSON.parse(all_data.detaildata)
      this.filterDatas = this.formDatas

      // 获得险种选项
      let str = ''
      for(let i in this.formDatas) {
        let reg = this.filterDatas[i].insurance_type
        if (reg === '其他') continue
        let exist = str.match(reg)
        if(!exist) {
          let obj = {label: this.formDatas[i].insurance_type, value: this.insurance_type_options.length}
          str += this.formDatas[i].insurance_type
          this.insurance_type_options.push(obj)
        }
      }
      this.insurance_type_options.push({label:'其他', value: this.insurance_type_options.length})

      this.setPage()
    },
    setPage() {
      // 进行分页的操作
      this.page.total = this.filterDatas.length
      this.formData = this.filterDatas.slice((this.page.currentPage - 1)*this.page.pageSize,this.page.currentPage*this.page.pageSize)
    },
    pageChange ({ currentPage, pageSize }) {
      // 页数切换
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.setPage()
    },
    cellClickEvent({row, column}) {
      // Coverage列切换至Coverage组件
      if (column.property === "insurance_num" || column.property === "policy_holder" || column.property === "info") {
        // var data = row
        window.sessionStorage.setItem('ins_esg_details', JSON.stringify(row))
        this.$router.push({path: '/insuranceesgdetails'})
      }
    },
    cellClassName({row,column}){
      if (column.property === "insurance_num" || column.property === "policy_holder" || column.property === "info"){
        return 'report-turn-details'
      }
      if (column.property === "esg_"){
        if(row.esg_ === "A") return 'report-level-A'
        if(row.esg_ === "B") return 'report-level-B'
        if(row.esg_ === "C") return 'report-level-C'
        if(row.esg_ === "D") return 'report-level-D'
      }
    },
    // 排序
    sortChangeEvent ({ sortList }) {
      sortList.map((item) => `${item.property},${item.order}`).join('; ')
    },
    // 筛选检索
    filter (option) {
      let reg = option
      let array = []
      let attr = ''
      if(reg == this.filter_insurance_type)
        attr = 'insurance_type'
      else if(reg == this.filter_company)
        attr = 'policy_holder'
      else return
      for(let i in this.filterDatas) {
        let temp = this.filterDatas[i][attr].match(reg)
        if(temp) array.push(this.filterDatas[i])
      }
      this.filterDatas = array
      this.setPage()
    },
    filterAll () {
      this.filterDatas = this.formDatas
      this.filter (this.filter_insurance_type)
      this.filter (this.filter_company)
      this.setPage()
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  watch: {
    filter_company: function () {
      this.filterAll()
    },
    filter_insurance_type: function () {
      this.filterAll()
    }
  },
  computed: {
    tableColumns() {
      return [
        { field: 'insurance_num', title: this.$t('insurance.policy_id'), width: 100 },
        { field: 'policy_holder', title: this.$t('common.company_name'), sortable: true },
        { field: 'insurance_type', title: this.$t('insurance.insurance_kind'), showHeaderOverflow: true, sortable: true },
        { field: 'esg', title: this.$t('insurance.esg_risk_factor'), sortable: true, formatter: ({cellValue,row})=>{
            return parseInt(row.Environmental) + parseInt(row.Social) + parseInt(row.Governance)
          } },
        { field: 'insurance_fee', title: this.$t('insurance.insurance_rate'), showOverflow: true, sortable: true, formatter:({cellValue,row})=>{
          return (cellValue / row.pay_limit * 100).toFixed(2) + '%'
          } },
        { field: 'Environmental', title: this.$t('insurance.e_risk_factor'), showOverflow: true, sortable: true, formatter: ({cellValue})=>{
          return parseInt(cellValue)
        } },
        { field: 'Social', title: this.$t('insurance.s_risk_factor'), showOverflow: true, sortable: true, formatter: ({cellValue})=>{
            return parseInt(cellValue)
          } },
        { field: 'Governance', title: this.$t('insurance.g_risk_factor'), showOverflow: true, sortable: true, formatter: ({cellValue})=>{
            return parseInt(cellValue)
          } },
        { field: 'esg_', title: this.$t('insurance.esg_risk_rating'), sortable: true, showOverflow: true },
        { field: 'info', title: this.$t('common.detail'), showOverflow: true, formatter(cellValue) {
          return'详情'
          } }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_report.js